import { Switch } from '@headlessui/react';
import classNames from 'classnames';
import Styles from './style.module.scss';
import male from 'assets/img/male.png';
import female from 'assets/img/female.png';
type Props = {
  enabled?: boolean;
  onChange?: (status: boolean) => void;
};

export default function ToggleButton({
  enabled = false,
  onChange = () => {},
}: Props) {
  const onChangeEvent = (value: boolean) => {
    onChange(value);
  };
  return (
    <Switch
      checked={enabled}
      onChange={onChangeEvent}
      className={classNames(
        Styles.wrapper,
        { [Styles.activeAddition]: enabled === true },
        { [Styles.unActiveAddition]: enabled === false }
      )}
    >
      <span
        aria-hidden='true'
        className={classNames(
          Styles.handle,
          { [Styles.activeAddition]: enabled === true },
          { [Styles.unActiveAddition]: enabled === false }
        )}
      />
      <div className={Styles.tagNameList}>
        <p
          className={classNames(
            Styles.tagName,
            { [Styles.activeAddition]: enabled === false },
            { [Styles.unActiveAddition]: enabled === true }
          )}
        >
          Male
        </p>
        <p
          className={classNames(
            Styles.tagName,
            { [Styles.activeAddition]: enabled === true },
            { [Styles.unActiveAddition]: enabled === false }
          )}
        >
          Female
        </p>
      </div>
      <img src={male} className={Styles.icon1} />
      <img src={female} className={Styles.icon2} />
    </Switch>
  );
}
